<script lang="ts">
    import { fly } from "svelte/transition";
    import LL from "../../../../i18n/i18n-svelte";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import { isMobileOnboarding } from "../../../Stores/OnboardingStore";

    interface Props {
        onnext?: () => void;
        onskip?: () => void;
    }

    const { onnext, onskip }: Props = $props();

    let worldName: string = gameManager.getCurrentGameScene()?.room?.roomName ?? "Куб.Мета";

    function handleNext() {
        onnext?.();
    }

    function handleSkip() {
        onskip?.();
    }
</script>

<div
    class="z-3001 pointer-events-auto {$isMobileOnboarding
        ? 'fixed left-4 right-4 bottom-4'
        : 'fixed left-1/2 top-20 transform -translate-x-1/2'}"
>
    <div
        data-testid="onboarding-card"
        class="bg-mlight/80 shadow-light rounded-md2 backdrop-blur-lg p-4 sm:p-6 w-full max-w-[550px] border border-white/20 {$isMobileOnboarding
            ? 'mx-auto max-h-[70vh] overflow-y-auto'
            : ''}"
        in:fly={{ y: $isMobileOnboarding ? -10 : 10, duration: 400 }}
    >
        <div class="text-center">
            <h2 class="text-3xl font-bold mb-3 text-[32px] leading-8">
                {$LL.onboarding.welcome.title({ worldName })}
            </h2>
            <p class="text-base text-mdark/90 m-0">
                {$LL.onboarding.welcome.description()}
            </p>
            <div class="flex justify-center gap-4 mt-5">
                <button
                    class="px-5 py-3 bg-mblue hover:bg-mblue-darker text-white rounded-lg font-medium transition-all text-[13px]"
                    data-testid="onboarding-button-welcome-start"
                    onclick={handleNext}
                >
                    {$LL.onboarding.welcome.start()}
                </button>
                <button
                    class="px-5 py-3 bg-white rounded-lg font-medium transition-all border border-solid border-transparent hover:border-mblue text-[13px]"
                    data-testid="onboarding-button-welcome-skip"
                    onclick={handleSkip}
                >
                    {$LL.onboarding.welcome.skip()}
                </button>
            </div>
        </div>
    </div>
</div>
